module.exports = __webpack_public_path__ + "static/media/arab.e500d0a5.svg";